<template>
  <v-dialog v-model="intDialogVisible" max-width="800px" class="addValueModal addComment">
    <v-card>
      <v-card-text>

        <v-form class="px-3"  @submit.prevent="submit">
          <div class="" v-if='current_step == 1'>


          <div class="zone_input">
            <div class="oneField">
              <span class="fieldTitle">Organization name<sup class="required">*</sup></span>
              <div class="info_startup_2">
                <input type="text" class="innopearl_input" placeholder="Organization name" v-model="connect.name">
              </div>
              <div class="alert alert-warning text-left mt-3 " v-if="v$.connect.name.$errors.length > 0">
                  <div  v-for="(error, index) of v$.connect.name.$errors" :key="index">{{ error.$message }}</div>
              </div>
            </div>

          </div>

          <div class="zone_input">
            <div class="oneField">
              <span class="fieldTitle">Company type<sup class="required">*</sup></span>
              <div class="info_startup_2">
                <v-autocomplete v-model="connect.company_type" placeholder="Your company type" chips closable-chips  :items="company_types" item-color="#FFF" item-title="name" item-value="value" return-object></v-autocomplete>
              </div>
              <div class="alert alert-warning text-left mt-3 " v-if="v$.connect.company_type.$errors.length > 0">
                  <div  v-for="(error, index) of v$.connect.company_type.$errors" :key="index">{{ error.$message }}</div>
              </div>
            </div>

          </div>

          <div class="zone_input">
            <div class="oneField">
              <span class="fieldTitle">Contact name<sup class="required">*</sup></span>
              <div class="info_startup_2">
                <input type="text" class="innopearl_input" placeholder="Your full name" v-model="connect.key_contact_name">
              </div>
              <div class="alert alert-warning text-left mt-3 " v-if="v$.connect.key_contact_name.$errors.length > 0">
                  <div  v-for="(error, index) of v$.connect.key_contact_name.$errors" :key="index">{{ error.$message }}</div>
              </div>
            </div>

          </div>
          <div class="zone_input">
            <div class="oneField">
              <span class="fieldTitle">Contact email<sup class="required">*</sup></span>
              <div class="info_startup_2">
                <input type="text" class="innopearl_input" placeholder="you@email.com" v-model="connect.key_contact_email">
              </div>
              <div class="alert alert-warning text-left mt-3 " v-if="v$.connect.key_contact_email.$errors.length > 0">
                  <div  v-for="(error, index) of v$.connect.key_contact_email.$errors" :key="index">{{ error.$message }}</div>
              </div>
            </div>


          </div>

          <div class="zone_input">
            <div class="oneField">
              <span class="fieldTitle">Website<sup class="required">*</sup></span>
              <div class="info_startup_2">
                <input type="text" class="innopearl_input"  @input="toLowercase"  placeholder="Your website URL" v-model="connect.website">
              </div>
              <div class="alert alert-warning text-left mt-3 " v-if="v$.connect.website.$errors.length > 0">
                  <div  v-for="(error, index) of v$.connect.website.$errors" :key="index">{{ error.$message }}</div>
              </div>
            </div>

          </div>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn @click="close" >
              Cancel
            </v-btn>
            <v-btn class="addValue" @click="validator" v-if="steps == 1">
              Connect
            </v-btn>
            <v-btn class="addValue" @click="validatorAndNext" v-if="steps == 2">
              Next
            </v-btn>
          </v-card-actions>
            </div>
            <div class="" v-if='current_step == 2'>
              <div class="zone_input ">
                <div class="oneField">
                  <div class="info_startup_2">
                     <label for="legal_age" class="selectIt accept_terms" >
                       <input class="customizeCheckbox" type="checkbox" v-model="connect.legal_age" id="legal_age" >
                       <span class="custom-checkbox"><img :src="require('@/assets/checkInnoB.svg')" /></span>

                       <span class="radio-text">Check to confirm that you are at least 18 years of age<sup class="required">*</sup></span>
                     </label>

                   </div>
                </div>
                <div class="alert alert-warning text-left mt-3" v-if="showAllError && v$.connect.legal_age.$errors.length > 0">
                  <div v-for="(error, index) of v$.connect.legal_age.$errors" :key="index">{{ error.$message }}</div>
                </div>
              </div>
              <div class="zone_input mt20">
                <div class="oneField">
                  <!-- <span class="fieldTitle">Terms and conditions<sup class="required">*</sup></span> -->
                  <div class="info_startup_2">
                     <!-- <v-checkbox
                       v-model="connect.accept_terms"
                       label="I agree to Terms and Conditions (see below) *"
                     ></v-checkbox> -->
                     <!-- <div class="selectIt">
                       <label>
                         <input type="checkbox" v-model="connect.accept_terms" >
                         <span>I agree to Terms and Conditions (see below) <sup class="required">*</sup></span>
                       </label>
                     </div> -->
                     <label for="accept_terms" class="selectIt accept_terms" >
                       <input class="customizeCheckbox" type="checkbox" v-model="connect.accept_terms" id="accept_terms" >
                       <span class="custom-checkbox"><img :src="require('@/assets/checkInnoB.svg')" /></span>

                       <span class="radio-text">I agree to Terms and Conditions (see below) <sup class="required">*</sup></span>
                     </label>

                   </div>
                   <div class="alert alert-warning text-left mt-3" v-if="showAllError && v$.connect.accept_terms.$errors.length > 0">
                     <div v-for="(error, index) of v$.connect.accept_terms.$errors" :key="index">{{ error.$message }}</div>
                   </div>
                   <div class="details_term mt20">

                     <div class="terms_detail_inner">
                        {{lp.terms_and_conditions}}
                     </div>
                   </div>
                 </div>
               </div>

              <v-card-actions class="mt20">
                <v-spacer></v-spacer>
                <v-btn @click="close" >
                  Cancel
                </v-btn>
                <v-btn class="addValue" @click="validator" >
                  Connect
                </v-btn>

              </v-card-actions>
            </div>
        </v-form>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { useVuelidate } from '@vuelidate/core'
import { required, email,helpers } from '@vuelidate/validators'

export default {
  props: {
    dialogVisible: Boolean,
    formName: String,
    company_types: Array,
    lp: Object,
  },
  setup () {
   return { v$: useVuelidate() }
  },
  data () {
    return{
      connect:{
        name :"",
        key_contact_email:"",
        company_type : this.company_types[0],
        key_contact_name:"",
        website:"",
        accept_terms:false,
        legal_age:false,
      },
      current_step:1,
      steps: 1,
      returnedCustomerValue:'',
      showAllError:false,
    }
  },
  validations () {
    const acceptIfVisible = (message) =>
        helpers.withMessage(
          message,
          helpers.withParams({ type: 'requiredIfStep2' }, value => {
            if (this.steps !== 2 || this.current_step !== 2) return true
            return value === true
          })
        )


   return {
     connect:{
       // username: {
       //   required,
       // },
       name: {
         required:helpers.withMessage('Please provide your Company name', required),
       },
       company_type: {
         required:helpers.withMessage('Please provide your Company type', required),
       },
       key_contact_name: {
         required:helpers.withMessage('Please provide a Contact name', required),
       },
       website: {
         required:helpers.withMessage('Please provide a valid website URL', required),
       },
       key_contact_email: {
         required:helpers.withMessage('Please provide an email address', required),
         email:helpers.withMessage('Please provide a valid email address', email),
       },
       accept_terms: {
           required: acceptIfVisible('You must accept the terms and conditions')
       },
      legal_age: {
          required: acceptIfVisible('You must confirm that you are at least 18 years of age')
      }
     }

   }
 },
  methods:{
    toLowercase(event) {
                       event.target.value = event.target.value.toLowerCase();
                       this.connect.website = event.target.value;
                   },
    submit(){
      this.returnedCustomerValue = this.customerValue;
      this.customerValue = "";
       this.$emit('newValueIsProposed',this.returnedCustomerValue)
    },
    close(){
        this.$emit('close',false)
    },
    async validator(){
      const isFormCorrect = await this.v$.$validate()
      console.log(isFormCorrect);
      this.showAllError = true;
      if(isFormCorrect) this.$emit('wantToConnect',this.connect)
    },
    async validatorAndNext(){
      const isFormCorrect = await this.v$.$validate()
      console.log(isFormCorrect);
      if(isFormCorrect) this.current_step++;
    }
  },
  computed: {
    intDialogVisible: {
      get: function () {
        if (this.dialogVisible) {
          // Some dialog initialization code could be placed here
          // because it is called only when this.dialogVisible changes
        }

        return this.dialogVisible
      },
      set: function (value) {
             if (!value) {
                this.$emit('close', value);
             }
      }
    }
  },
  watch: {
    dialogVisible: function(){
      this.customerValue = "";
      this.connect.company_type = (this.company_types.length == 1 ) ? this.company_types[0] : null;
      if(this.lp?.terms_and_conditions && this.lp?.show_terms){
        if(this.lp.terms_and_conditions != "")this.steps = 2;
      }
    }
  }

}
</script>
<style scoped>

.zone_input{
}
.zone_input_icon{
  width: 55px;
}
.zone_input_name{
  text-align: left;
  font-size: 18px;
  line-height: 21px;
  color: #3783C5;
}
.zone_input_header{
  display:flex;
  gap: 10px;
  align-items: center;
  position:relative;
}
.mt20{
  margin-top: 20px;
}
.innopearl_input{
  border: 1px solid #DDDDDD;
border-radius: 2px;
box-sizing: border-box;
margin-top:10px;
margin-bottom: 10px;
height: 40px;
padding: 5px;
width:100%;
}
@media screen and (max-width: 990px){
.innopearl_input{
  width:100%;
  margin-left:0;
}
}
textarea{
  border: 1px solid #DDDDDD;
border-radius: 2px;
width: calc(100% - 65px);
margin-top:20px;
margin-bottom: 20px;
padding: 5px;
 resize: none;
 margin-left: 65px;
}


  .addValueModal .v-card{
    padding:10px;
  }
  .addValueModal .v-field__outline{
    display:none;
  }
  .formName{
    text-align: left;
    font-size: 21px;
    line-height: 25px;
    color: #3783C5;
  }
  .addValueModal button{
    border: 1px solid #3783C5;
    border-radius: 50px;
    opacity: 1;
    padding: 7px 18.5px;
    color:#3783C5;
    margin: 5px;
  }

    .addValueModal button.addValue{
      border: 1px solid #3783C5;

      background:#3783C5;
      color:#fff;
    }

    .addValueInput input{
      border: 1px solid #DDDDDD;
    }
  .addComment textarea{
    width: 100%;
margin: 0;
border: 1px solid #DDDDDD;
mask-image: none !important;
  }
  .v-card-title{
    white-space: normal !important;
  }

  .fieldTitle{
    font-weight:600;
    display:block;
  }
  .oneField{
    /* margin-top:20px; */
    display:block;
  }

  .info_startup_2{
    display: flex;
    gap: 10px;
  }
  .info_startup_2 .info_value{
    font-size:16px;
    line-height: 22px;
    width: 100%;
    resize-x:none;
  }
  .info_value{
  white-space: pre-wrap
  }


  .info_value_investment{
    width:auto !important;
    display:inline-block;
    max-width: 100px;
  }

  .selectDevise{
    border:1px solid #000;
    border-radius:10px;
    -webkit-appearance: auto;
    -moz-appearance :auto;
    padding:10px;
    max-width: 100px;

  }
  input,textarea{
  border: 1px solid #000;
  border-radius:10px;
    padding:10px;
    width:100%;

  }
.details_term > span{
  font-weight:600;
}
  .terms_detail_inner{
    max-height:200px;
    overflow-y:scroll;
    padding:10px;
    border:1px solid #CCC;

      white-space: pre-line;
  }

  .selectIt{


  display:flex;
  align-items: center;
  gap: 10px;
  }

    input[type="checkbox"].customizeCheckbox{
      display:none;
    }
    .custom-checkbox img{
          display:none;
          position: absolute;
    top: 3px;
    left: 3px;
    }

    .custom-checkbox {
        width: 25px; /* Circle diameter */
        height: 25px; /* Circle diameter */
        border: 2px solid #5081C1; /* Light gray border for unselected state */
        border-radius: 0%; /* Make it a circle */
        margin-right: 8px; /* Space between the circle and the text */
        transition: border-color 0.3s, background-color 0.3s; /* Smooth transition for color changes */
    }


    input[type="checkbox"].customizeCheckbox:checked + .custom-checkbox {
        border-color: #5081C1; /* Change border color when selected */
        background:#5081C1;
        position:relative;
    }
    input[type="checkbox"].customizeCheckbox:checked + .custom-checkbox > img{
        display:block;
    }

    label.accept_terms{
      color:#5081C1;
    }
</style>
